import { useGetNearbyPlayersCountQuery } from 'types/generated/client';
import { milesToMeters } from 'utils/shared/geo/milesToMeters';
import { useGeoLocation } from 'hooks/useGeoLocation';
import { useViewer } from 'hooks/useViewer';
import { FIND_RADIUS_MILES, toGeographyPoint } from 'screens/Find/geo';

/**
 * How many other players have an active availability near the viewer, plus the
 * viewer's city for the banner label. Same base radius as the /find tabs.
 */
export function useNearbyPlayersCount() {
  const viewer = useViewer();
  const { centerLatitude, centerLongitude } = useGeoLocation();

  const hasCenter = centerLatitude != null && centerLongitude != null;
  const { data } = useGetNearbyPlayersCountQuery({
    variables: {
      distance: milesToMeters(FIND_RADIUS_MILES),
      from: hasCenter ? toGeographyPoint({ lat: centerLatitude, lng: centerLongitude }) : null,
      viewerId: viewer.userId ?? '',
    },
    skip: !viewer.userId || !hasCenter,
  });

  return {
    count: data?.playerAvailabilitiesAggregate?.aggregate?.count ?? 0,
    city: data?.userProfiles?.[0]?.cityName || null,
  };
}
